import React, { useState } from "react";
import { Modal, Typography, Tag, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { AffectedSpecsList, AffectedSpecsModal } from "./AffectedSpecsList";

const { Title } = Typography;

const SPECS_PREVIEW_COUNT = 5;

export default function NotificationDetailModal({
  open,
  onClose,
  notification,
}) {
  const navigate = useNavigate();
  const [specsModalOpen, setSpecsModalOpen] = useState(false);

  if (!notification) return null;

  const isThreshold = notification.isThreshold;
  const specs = notification.specs || [];
  const previewSpecs = specs.slice(0, SPECS_PREVIEW_COUNT);

  return (
    <>
    <Modal
      open={open}
      onCancel={onClose}
      width={640}
      centered
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Title level={4} style={{ margin: 0 }}>
            {isThreshold ? "Defect Threshold Alert Event Details" : "Notification Details"}
          </Title>
          {isThreshold && (
            <Tag color={notification.severity === "critical" ? "red" : "orange"}>
              {notification.severity === "critical" ? "CRITICAL THRESHOLD" : "THRESHOLD EXCEEDED"}
            </Tag>
          )}
        </div>
      }
      footer={
        isThreshold
          ? [
              <Button key="close" onClick={onClose}>
                Close
              </Button>,
              <Button
                key="feedback"
                type="primary"
                onClick={() => {
                  onClose();
                  navigate("/excludedTab", { state: { tab: "completed" } });
                }}
              >
                View in Closed-Loop Feedback
              </Button>,
            ]
          : [
              <Button key="close" onClick={onClose}>
                Close
              </Button>,
            ]
      }
    >
      {isThreshold && (
        <div className="notif_comparison_card">
          <span className="notif_comparison_title">
            Closed-Loop Defect Trigger Condition
          </span>
          <div className="notif_comparison_values">
            <div className="notif_comp_cell">
              <div className="notif_comp_label">Defect Count</div>
              <div className="notif_comp_num notif_comp_num--alert">
                {notification.defectCount}
              </div>
            </div>
            <div className="notif_comp_cell">
              <div className="notif_comp_label">Current Rate</div>
              <div className="notif_comp_num">{notification.currentRate}</div>
            </div>
            <div className="notif_comp_cell">
              <div className="notif_comp_label">Baseline Rate</div>
              <div className="notif_comp_num">{notification.baselineRate}</div>
            </div>
          </div>
          <Tag color="red" style={{ fontWeight: 600 }}>
            Configured threshold: +{notification.thresholdPct}%
          </Tag>
        </div>
      )}

      {/* Meta Grid */}
      <div className="notif_detail_grid">
        <div className="notif_detail_tile">
          <span className="notif_detail_tile_label">Specification</span>
          <span className="notif_detail_tile_value">{notification.spec}</span>
        </div>
        <div className="notif_detail_tile">
          <span className="notif_detail_tile_label">Task Card No.</span>
          <span className="notif_detail_tile_value">{notification.cardNo}</span>
        </div>
        <div className="notif_detail_tile">
          <span className="notif_detail_tile_label">Aircraft Model</span>
          <span className="notif_detail_tile_value">{notification.flightModel}</span>
        </div>
      </div>

      <div className="notif_detail_field">
        <span className="notif_detail_field_label">Event Summary</span>
        <span className="notif_detail_field_value">{notification.message}</span>
      </div>

      {notification.taskDescription && (
        <div className="notif_detail_field">
          <span className="notif_detail_field_label">Task Description</span>
          <span className="notif_detail_field_value">
            {notification.taskDescription}
          </span>
        </div>
      )}

      {notification.actor && (
        <div className="notif_detail_field">
          <span className="notif_detail_field_label">Triggered By</span>
          <span className="notif_detail_field_value">{notification.actor}</span>
        </div>
      )}

      {specs.length > 1 && (
        <div>
          <div className="notif_detail_section_header">
            <span className="notif_detail_field_label">
              Affected Specs ({specs.length})
            </span>
            {specs.length > SPECS_PREVIEW_COUNT && (
              <Button
                type="link"
                size="small"
                style={{ padding: 0, fontSize: 12, height: "auto" }}
                onClick={() => setSpecsModalOpen(true)}
              >
                View All ({specs.length})
              </Button>
            )}
          </div>
          <AffectedSpecsList specs={previewSpecs} />
        </div>
      )}
    </Modal>

    <AffectedSpecsModal
      open={specsModalOpen}
      onClose={() => setSpecsModalOpen(false)}
      specs={specs}
    />
    </>
  );
}
